module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.project.projectId) ? _c('div', {
    staticClass: "project_main"
  }, [_c('div', {
    staticClass: "header_margin"
  }, [(_vm.project.projectId) ? _c('span', [_c('router-link', {
    staticClass: "fa fa-edit",
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "to": {
        path: '/Project/' + _vm.project.projectId
      },
      "tag": "a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.project.inactive) ? _c('span', {
    staticClass: "project_label",
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v("INACTIVE")])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "project_label"
  }, [_vm._v("Project Name:")]), _vm._v(" "), _c('span', {
    staticClass: "project_value"
  }, [_vm._v(_vm._s(_vm.project.name))]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "project_label"
  }, [_vm._v("DB Number:")]), _vm._v(" "), _c('span', {
    staticClass: "project_value"
  }, [_vm._v(_vm._s(_vm.project.dbNumber))])]), _vm._v(" "), (_vm.project.expeditedReview) ? _c('span', {
    staticClass: "project_label",
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v("EO 14156")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header_margin"
  }, [_c('span', [_c('span', {
    staticClass: "project_label"
  }, [_vm._v("Project Type:")]), _vm._v(" "), _c('span', {
    staticClass: "project_value"
  }, [_vm._v(_vm._s(_vm.project.projectTypeDescription))])])]), _vm._v(" "), _c('div', {
    staticClass: "header_margin"
  }, [_c('span', [_c('span', {
    staticClass: "project_label"
  }, [_vm._v("Lead Agency:")]), _vm._v(" "), _c('span', {
    staticClass: "project_value"
  }, [_vm._v(_vm._s(_vm.leadAgencyDescription))])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "project_label"
  }, [_vm._v("Agency Number:")]), _vm._v(" "), _c('span', {
    staticClass: "project_value"
  }, [_vm._v(_vm._s(_vm.project.agencyNumber))])])]), _vm._v(" "), _c('div', {
    staticClass: "header_margin"
  }, [_c('span', [_c('span', {
    staticClass: "project_label"
  }, [_vm._v("Client:")]), _vm._v(" "), _c('span', {
    staticClass: "project_value"
  }, [_vm._v(_vm._s(_vm.clientDescription))])])]), _vm._v(" "), _c('div', {
    staticClass: "header_margin"
  }, [_c('span', [_c('span', {
    staticClass: "project_label"
  }, [_vm._v("Field Org:")]), _vm._v(" "), _c('span', {
    staticClass: "project_value"
  }, [_vm._v(_vm._s(_vm.fieldOrgDescription))])]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "project_label"
  }, [_vm._v("Field Org Number:")]), _vm._v(" "), _c('span', {
    staticClass: "project_value"
  }, [_vm._v(_vm._s(_vm.project.fieldOrgNumber))])]), _vm._v(" "), (_vm.isShpo) ? _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "10px 10px 0px 20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin": "0"
    },
    on: {
      "click": function($event) {
        _vm.$refs['commentModal'].open()
      }
    }
  }, [_vm._v("\n              SHPO Comments "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.commentList.length))])])]) : _vm._e(), _vm._v(" "), (_vm.isShpo) ? _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "10px 10px 0px 20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin": "0"
    },
    on: {
      "click": function($event) {
        _vm.$refs['randcModal'].open()
      }
    }
  }, [_vm._v("\n              RandC Data\n          ")])]) : _vm._e()]), _vm._v(" "), _c('modal', {
    ref: "commentModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left align-bottom"
  }, [_vm._v("SHPO Comments")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['commentModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.commentList,
      "columns": _vm.commentGridSpec.columns,
      "options": _vm.commentGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteComment(props.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentDto.comment),
      expression: "commentDto.comment"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentDto.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.commentDto, "comment", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "save"
    },
    on: {
      "click": function($event) {
        _vm.saveShpoComment()
      }
    }
  }, [_vm._v("Add Comment")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['commentModal'].close()
      }
    }
  }, [_vm._v("Close")])])])]), _vm._v(" "), _c('modal', {
    ref: "randcModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left align-bottom"
  }, [_vm._v("RandC Data")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['randcModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.projectRandCList,
      "columns": _vm.randcGridSpec.columns,
      "options": _vm.randcGridSpec.options
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {}, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "type": "button",
      "name": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.$refs['randcModal'].close()
      }
    }
  }, [_vm._v("Close")])])])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b0bda22"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectHeader.vue
// module id = 945
// module chunks = 1